import axios from 'axios';
import { IResponse } from '~/services/api/types';
import {
  IHospitalCounters,
  IHospitalDetails,
  IHospitalHistoryItem,
  IHospitalEventList,
  IHospitalListFilters,
  IHospitalSelectors,
} from './types';

const apiUrl = 'hospital';

export const getCounters = (params: IHospitalListFilters): IResponse<IHospitalCounters> =>
  axios({
    method: 'get',
    url: `${apiUrl}/counters`,
    params,
  });

export const getEventsList = (params: IHospitalListFilters): IResponse<IHospitalEventList[]> =>
  axios({
    method: 'get',
    url: `${apiUrl}/events`,
    params,
  });

export const getSelectors = (): IResponse<IHospitalSelectors> =>
  axios({
    method: 'get',
    url: `${apiUrl}/selectors`,
  });

export const getById = (id: number): IResponse<IHospitalDetails> =>
  axios({
    method: 'get',
    url: `${apiUrl}/events/${id}`,
  });

export const getHistoryByPatientId = (patientId: number): IResponse<IHospitalHistoryItem[]> =>
  axios({
    method: 'get',
    url: `${apiUrl}/by-patient-id/${patientId}/history`,
  });

export default {};
